import { PortalContext } from "App";
import { useContext, useEffect } from "react";

/**
 * hook to contain logic for master-portal specific page refreshing control
 *
 * @param {Object} props
 * @param {String} props.pagePath The page path of the caller
 * @param {Boolean} props.preventRefresh  Will prevent refresh flow from triggering if true
 * @param {Function} props.redirectFn redirectFn from the props of caller
 * @param {Function} props.effectFn Will be ran if refresh conditions are met
 * @returns
 */
const useRefresh = ({ pagePath, preventRefresh, redirectFn, effectFn }) => {
  const stateContext = useContext(PortalContext);
  const { currentPath, detailPageState } = stateContext;

  useEffect(() => {
    let refresh = false;
    const sessionState = JSON.parse(sessionStorage.getItem("state"));
    if (
      currentPath === pagePath &&
      (detailPageState?.refresh?.includes(pagePath) ||
        sessionState?.refresh?.includes(pagePath))
    ) {
      refresh = true;
    }

    if (refresh && effectFn) {
      redirectFn("refreshed", { path: pagePath });
      if (!preventRefresh) effectFn();
    }
  });
};

export default useRefresh;
